// radioFieldPlugin.js
import { helpers } from '@vuelidate/validators'

import RadioFieldPlugin from './RadioFieldPlugin.vue'
import RadioFieldPluginValueRenderer from './RadioFieldPluginValueRenderer.vue'

const defaultData = {
  options: [], // [{label: 'Option 1', value: 1}, {label: 'Option 2', value: 2}]
}

export const radioFieldPlugin = {
  type: 'radio',
  component: RadioFieldPlugin,
  valueRenderer: RadioFieldPluginValueRenderer,
  defaultExtraData: defaultData,
  getValidations({ props }) {
    const field = props.field
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory
    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, value => !!value)
    }

    return rules
  },
}
